import { useEffect } from "react";
import { applyPageMeta, resetPageMeta, type PageMeta } from "../lib/pageMeta";

export function usePageMeta(meta: PageMeta | null | undefined): void {
  const title = meta?.title;
  const description = meta?.description;
  const ogTitle = meta?.ogTitle;
  const ogDescription = meta?.ogDescription;
  const ogUrl = meta?.ogUrl;

  useEffect(() => {
    if (!meta) return;

    applyPageMeta(meta);

    return () => {
      resetPageMeta();
    };
  }, [meta, title, description, ogTitle, ogDescription, ogUrl]);
}
